/**
 * คำนวณ blurhash จากรูปใน browser (ใช้ canvas + blurhash.encode)
 * รองรับทุก format ที่ browser decode ได้ (JPEG, PNG, WebP, AVIF)
 */

import { encode } from "blurhash";

const BLURHASH_SIZE = 32;

/**
 * โหลด Blob เป็น HTMLImageElement
 */
function loadImageFromBlob(blob: Blob): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(blob);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("Failed to load image"));
    };
    img.src = url;
  });
}

/**
 * คำนวณ blurhash จาก Blob (รูปที่บีบแล้วหรือไฟล์ต้นทาง)
 * ใช้ canvas ขนาดเล็ก (32x32) เพื่อความเร็ว
 */
export async function getBlurhashFromBlob(blob: Blob): Promise<string | null> {
  try {
    const img = await loadImageFromBlob(blob);
    const width = img.naturalWidth;
    const height = img.naturalHeight;
    if (width === 0 || height === 0) return null;

    const size = Math.min(BLURHASH_SIZE, width, height);
    const canvas = document.createElement("canvas");
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext("2d");
    if (!ctx) return null;
    ctx.drawImage(img, 0, 0, size, size);
    const imageData = ctx.getImageData(0, 0, size, size);
    return encode(imageData.data, size, size, 4, 4);
  } catch {
    return null;
  }
}
